import React, { useCallback, useRef } from 'react';

import { message } from 'antd';
import cn from 'classnames';
import Image from 'next/legacy/image';

import { Button } from '@element/index'
import { createImg, createQRCode, downImg, drawAirdrop } from '@utils/createPoster'
import I18n from '@utils/i18n';
import { copyText } from '@utils/index'
import { CardDown } from '@widget/airdrop/countdown';

import { openModalIconClose } from './ModalIconClose';

import styles from './index.module.less';
interface ContentProps {
  /** 结束时间 */
  endTime: number;
  /** 总数量 */
  allCount: number;
  /** 祝福语 */
  greeting: string;
  /** 币种 */
  shareCount: number;
  shareLink: any;
  title: string;
}

const Content: React.FC<ContentProps> = (props) => {
  const {
    endTime, allCount = 0,
    shareCount = 0, shareLink,
    title = '',
    greeting = ''
  } = props;
  const canvasRef = useRef<HTMLCanvasElement>();
  const downRef = useRef('')

  const copyDesc = I18n.t('wAt06ohh')

  const copyContent = `${copyDesc}\n\n${shareLink || ''}`

  const handleCopy = () => {
    copyText(copyContent)
    message.success(I18n.t('copySuccess'))
  }
  const createAirdropPoster = async () => {
    const qrcodeUrl = await createQRCode(shareLink, { width: 120, height: 120 });
    const kikiLogoUrl = require('@images/logo_dark_bg.webp')
    const boxImgUrl = require('@images/airdrop/airdropPosterBox.webp')
    const [qrcodeImg, kikiLogo, boxImg] = await Promise.all([
      createImg(qrcodeUrl),
      createImg(kikiLogoUrl.default.src),
      createImg(boxImgUrl.default.src)
    ]);
    const { url, canvas } = drawAirdrop({ qrcodeImg, title, kikiLogo, boxImg, subTitle: greeting })
    downRef.current = url;
    canvasRef.current = canvas;
    downImg(downRef.current)
  }

  const onSharePostClick = useCallback(() => {
    createAirdropPoster()
  }, [shareLink])

  return (
    <div className={styles.lottieWrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{I18n.t('hWGI8S6k')}</div>
        <div className={styles.desc}>{shareCount || 0}/{allCount || 0}</div>
        <CardDown className={styles.countDown} endTime={endTime} id={'modalCount'}/>
      </div>
      <div className={styles.boxWrapper}>
        <div className={styles.boxImg}>
          <Image src={require('@images/airdrop/question.webp')} alt="kikitrade" />
        </div>
      </div>
      <div className={styles.shareContent}>
        {copyContent}
      </div>
      <div className={styles.btnWrapper}>
        <Button
          type='ghost'
          className={cn(styles.btnItem, styles.cancel)}
          onClick={onSharePostClick}
          data-buried='download-post'>{I18n.t('tdTJtpAt')}</Button>
        <Button
          type='primary'
          className={cn(styles.btnItem, styles.primary)}
          onClick={handleCopy}
          data-buried='copy-link'>{I18n.t('aMsfCYHG')}</Button>
      </div>
      <div className={styles.bottomTips}>{I18n.t('qhd8DoCj')}</div>
    </div>
  );
}

interface IOpenModalBgParams extends Pick<ContentProps,
'allCount' | 'endTime' | 'shareCount' | 'shareLink' | 'title' | 'greeting'> {
  el: HTMLElement;
}

export const openShareModal = ({ el, ...rest }: IOpenModalBgParams) => {
  return openModalIconClose({
    el,
    className: styles.topContainer,
    children: () => <Content {...rest} />
  })
}
